import React from "react";
import { CreditCard, Heart } from "lucide-react";
import { PaystackButton as PSButton } from "react-paystack";

// Paystack Button Component (for sidebar)
export const PaystackButton = ({ config, onSuccess, onClose, donorEmail, donationAmount }) => {
  if (!donationAmount || !donorEmail) {
    return (
      <button 
        className="w-full bg-white text-[#00C3F7] hover:bg-gray-100 px-6 py-4 rounded-xl font-semibold transition-colors inline-flex items-center justify-center gap-2 opacity-50 cursor-not-allowed"
        disabled
      >
        <CreditCard className="w-5 h-5" />
        Pay with Paystack
      </button>
    );
  }

  const paystackConfig = {
    reference: `donation_${new Date().getTime()}`,
    email: donorEmail,
    amount: donationAmount * 100, // Paystack expects amount in kobo (cents)
    publicKey: config.public_key,
    metadata: {
      custom_fields: [
        {
          display_name: "Donation Type",
          variable_name: "donation_type",
          value: config.meta?.donation_type || "one-time",
        },
      ],
    },
  };

  return (
    <PSButton
      {...paystackConfig}
      className="w-full bg-white text-[#00C3F7] hover:bg-gray-100 px-6 py-4 rounded-xl font-semibold transition-colors inline-flex items-center justify-center gap-2"
      text="Pay with Paystack"
      onSuccess={(response) => {
        onSuccess(response);
      }}
      onClose={() => {
        onClose();
      }}
    />
  );
};

// Main Donate Now Button with Paystack
export const PaystackButtonMain = ({ config, onSuccess, onClose, donorEmail, donationAmount }) => {
  if (!donationAmount || !donorEmail) {
    return (
      <button 
        className="w-full bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-full font-medium text-sm transition-colors inline-flex items-center justify-center gap-2 opacity-50 cursor-not-allowed"
        disabled
      >
        <Heart className="w-5 h-5" /> DONATE NOW
      </button>
    );
  }

  const paystackConfig = {
    reference: `donation_${new Date().getTime()}`,
    email: donorEmail,
    amount: donationAmount * 100, // Paystack expects amount in kobo (cents)
    publicKey: config.public_key,
    metadata: {
      custom_fields: [
        {
          display_name: "Donation Type",
          variable_name: "donation_type",
          value: config.meta?.donation_type || "one-time",
        },
      ],
    },
  };

  return (
    <PSButton
      {...paystackConfig}
      className="w-full bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-full font-medium text-sm transition-colors inline-flex items-center justify-center gap-2"
      text="DONATE NOW"
      onSuccess={(response) => {
        onSuccess(response);
      }}
      onClose={() => {
        onClose();
      }}
    />
  );
};
